import {
	PostLoginActionsTypes, PostLoginModel,
	DefaultRegisterActionsTypes
} from './types';

export const postLoginRequest  = (model: PostLoginModel) => (
	{
		type: PostLoginActionsTypes.POST_LOGIN,
		model		
	}
);

export const checkLoggedIn = () => (
	{
		type: DefaultRegisterActionsTypes.DEFAULT_REGISTER
	}
);